// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { HistoryReadKind } from "./history-read-kind";
import { NodeId, NodeIdT, verifyNodeId } from "./node-id";

/**
 * Configuration for a historical read of a node.
 */
export class HistoryReadConfig implements flatbuffers.IUnpackableObject<HistoryReadConfigT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): HistoryReadConfig {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsHistoryReadConfig(
    bb: flatbuffers.ByteBuffer,
    obj?: HistoryReadConfig,
  ): HistoryReadConfig {
    return (obj || new HistoryReadConfig()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsHistoryReadConfig(
    bb: flatbuffers.ByteBuffer,
    obj?: HistoryReadConfig,
  ): HistoryReadConfig {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new HistoryReadConfig()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  nodeId(obj?: NodeId): NodeId | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new NodeId()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  kind(): HistoryReadKind {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : HistoryReadKind.Raw;
  }

  /**
   * ISO-8601 start time (inclusive). Empty = open-ended.
   */
  startTime(): string | null;
  startTime(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  startTime(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * ISO-8601 end time (inclusive). Empty = open-ended.
   */
  endTime(): string | null;
  endTime(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  endTime(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Max values per node (0 = no limit).
   */
  numValuesPerNode(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  /**
   * Return the bounding values around the time range.
   */
  returnBounds(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  /**
   * For Processed reads: the aggregate function node id.
   */
  aggregateTypeId(obj?: NodeId): NodeId | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset
      ? (obj || new NodeId()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * For Processed reads: processing interval in milliseconds.
   */
  processingIntervalMs(): number {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.readFloat64(this.bb_pos + offset) : 0.0;
  }

  static startHistoryReadConfig(builder: flatbuffers.Builder) {
    builder.startObject(8);
  }

  static addNodeId(builder: flatbuffers.Builder, nodeIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, nodeIdOffset, 0);
  }

  static addKind(builder: flatbuffers.Builder, kind: HistoryReadKind) {
    builder.addFieldInt8(1, kind, HistoryReadKind.Raw);
  }

  static addStartTime(builder: flatbuffers.Builder, startTimeOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, startTimeOffset, 0);
  }

  static addEndTime(builder: flatbuffers.Builder, endTimeOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, endTimeOffset, 0);
  }

  static addNumValuesPerNode(builder: flatbuffers.Builder, numValuesPerNode: number) {
    builder.addFieldInt32(4, numValuesPerNode, 0);
  }

  static addReturnBounds(builder: flatbuffers.Builder, returnBounds: boolean) {
    builder.addFieldInt8(5, +returnBounds, +false);
  }

  static addAggregateTypeId(
    builder: flatbuffers.Builder,
    aggregateTypeIdOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(6, aggregateTypeIdOffset, 0);
  }

  static addProcessingIntervalMs(builder: flatbuffers.Builder, processingIntervalMs: number) {
    builder.addFieldFloat64(7, processingIntervalMs, 0.0);
  }

  static endHistoryReadConfig(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // node_id
    return offset;
  }

  unpack(): HistoryReadConfigT {
    return new HistoryReadConfigT(
      this.nodeId() !== null ? this.nodeId()!.unpack() : null,
      this.kind(),
      this.startTime(),
      this.endTime(),
      this.numValuesPerNode(),
      this.returnBounds(),
      this.aggregateTypeId() !== null ? this.aggregateTypeId()!.unpack() : null,
      this.processingIntervalMs(),
    );
  }

  unpackTo(_o: HistoryReadConfigT): void {
    _o.nodeId = this.nodeId() !== null ? this.nodeId()!.unpack() : null;
    _o.kind = this.kind();
    _o.startTime = this.startTime();
    _o.endTime = this.endTime();
    _o.numValuesPerNode = this.numValuesPerNode();
    _o.returnBounds = this.returnBounds();
    _o.aggregateTypeId = this.aggregateTypeId() !== null ? this.aggregateTypeId()!.unpack() : null;
    _o.processingIntervalMs = this.processingIntervalMs();
  }

  unpackFields(...fields: string[]): HistoryReadConfigT {
    const t = new HistoryReadConfigT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("node_id")) {
      t.nodeId = this.nodeId() !== null ? this.nodeId()!.unpack() : null;
    }
    if (fieldSet.has("kind")) {
      t.kind = this.kind();
    }
    if (fieldSet.has("start_time")) {
      t.startTime = this.startTime();
    }
    if (fieldSet.has("end_time")) {
      t.endTime = this.endTime();
    }
    if (fieldSet.has("num_values_per_node")) {
      t.numValuesPerNode = this.numValuesPerNode();
    }
    if (fieldSet.has("return_bounds")) {
      t.returnBounds = this.returnBounds();
    }
    if (fieldSet.has("aggregate_type_id")) {
      t.aggregateTypeId = this.aggregateTypeId() !== null ? this.aggregateTypeId()!.unpack() : null;
    }
    if (fieldSet.has("processing_interval_ms")) {
      t.processingIntervalMs = this.processingIntervalMs();
    }
    return t;
  }
}

export class HistoryReadConfigT implements flatbuffers.IGeneratedObject {
  constructor(
    public nodeId: NodeIdT | null = null,
    public kind: HistoryReadKind = HistoryReadKind.Raw,
    public startTime: string | Uint8Array | null = null,
    public endTime: string | Uint8Array | null = null,
    public numValuesPerNode: number = 0,
    public returnBounds: boolean = false,
    public aggregateTypeId: NodeIdT | null = null,
    public processingIntervalMs: number = 0.0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.nodeId === null || this.nodeId === undefined) {
      throw new Error('Required field "node_id" is not set');
    }
    const nodeId = this.nodeId !== null ? this.nodeId!.pack(builder) : 0;
    const startTime = this.startTime !== null ? builder.createString(this.startTime!) : 0;
    const endTime = this.endTime !== null ? builder.createString(this.endTime!) : 0;
    const aggregateTypeId = this.aggregateTypeId !== null ? this.aggregateTypeId!.pack(builder) : 0;

    HistoryReadConfig.startHistoryReadConfig(builder);
    HistoryReadConfig.addNodeId(builder, nodeId);
    HistoryReadConfig.addKind(builder, this.kind);
    HistoryReadConfig.addStartTime(builder, startTime);
    HistoryReadConfig.addEndTime(builder, endTime);
    HistoryReadConfig.addNumValuesPerNode(builder, this.numValuesPerNode);
    HistoryReadConfig.addReturnBounds(builder, this.returnBounds);
    HistoryReadConfig.addAggregateTypeId(builder, aggregateTypeId);
    HistoryReadConfig.addProcessingIntervalMs(builder, this.processingIntervalMs);

    return HistoryReadConfig.endHistoryReadConfig(builder);
  }

  clone(): HistoryReadConfigT {
    const obj = new HistoryReadConfigT();
    obj.nodeId = this.nodeId !== null ? this.nodeId!.clone() : null;
    obj.kind = this.kind;
    obj.startTime = this.startTime;
    obj.endTime = this.endTime;
    obj.numValuesPerNode = this.numValuesPerNode;
    obj.returnBounds = this.returnBounds;
    obj.aggregateTypeId = this.aggregateTypeId !== null ? this.aggregateTypeId!.clone() : null;
    obj.processingIntervalMs = this.processingIntervalMs;
    return obj;
  }

  equals(other: HistoryReadConfigT): boolean {
    if (this.nodeId !== null && other.nodeId !== null) {
      if (!this.nodeId!.equals(other.nodeId!)) return false;
    } else if (this.nodeId !== other.nodeId) return false;
    if (this.kind !== other.kind) return false;
    if (this.startTime !== other.startTime) return false;
    if (this.endTime !== other.endTime) return false;
    if (this.numValuesPerNode !== other.numValuesPerNode) return false;
    if (this.returnBounds !== other.returnBounds) return false;
    if (this.aggregateTypeId !== null && other.aggregateTypeId !== null) {
      if (!this.aggregateTypeId!.equals(other.aggregateTypeId!)) return false;
    } else if (this.aggregateTypeId !== other.aggregateTypeId) return false;
    if (!Object.is(this.processingIntervalMs, other.processingIntervalMs)) return false;
    return true;
  }
}

export function verifyHistoryReadConfig(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyNodeId(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "node_id");
    verifier.checkScalarField(tablePos, 6, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 12, 4);
    verifier.checkScalarField(tablePos, 14, 1);
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 16);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyNodeId(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkScalarField(tablePos, 18, 8);
  } finally {
    verifier.popDepth();
  }
}
